import React from "react";
import "./MenuRight.css";

function MenuTwo() {
  return (
    <>
      <div className="secondMenu">
        <ul>
          <li>
            <a href="blank">
              Store<span>&</span>Lifestyle
            </a>
          </li>
          <li>
            <a href="blank">Enquiry</a>
          </li>
          <li>
            <a href="blank">Dealers</a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default MenuTwo;